import { Component } from '@angular/core';
import {
  AbstractControlOptions,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { IError } from 'src/app/_types/common.types';
import { ILoginResponse } from 'src/app/_types/corporator.types';
import { ROLES } from 'src/app/constant/db.constant';
import { AuthService } from 'src/app/services/auth.service';
import { FormService } from 'src/app/shared/services/form.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { NotifierService } from 'src/app/shared/services/notifier.service';
import { SessionService } from 'src/app/shared/services/session.service';
import {
  formNoWhitespaceValidator,
  patterns,
} from 'src/app/validators/pattern_validation';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  isAdmin: boolean = false;
  loginForm: FormGroup;
  confirmPassword = false;
  private unsubscribe$ = new Subject<void>();
  loading: boolean = false;

  constructor(
    private activeRoute: ActivatedRoute,
    public router: Router,
    private _FormBuilder: FormBuilder,
    private _AuthService: AuthService,
    private _NotifierService: NotifierService,
    private _SessionService: SessionService,
    private _LoaderService: LoaderService,
    private formService: FormService
  ) {
    this.loginForm = this._FormBuilder.group(
      {
        email: [
          '',
          [Validators.pattern(patterns.EMAIL.regex), Validators.required],
        ],
        password: ['', [Validators.required]],
      },
      { validators: [formNoWhitespaceValidator] } as AbstractControlOptions
    );
  }

  ngOnInit() {
    this.isAdmin =
      this.activeRoute.snapshot.routeConfig?.path === 'admin-login';
  }

  togglePasswordVisibility() {
    this.confirmPassword = !this.confirmPassword;
  }

  getErrorMessage(controlName: string): string {
    return this.formService.getErrorMessage(controlName, this.loginForm);
  }

  login() {
    if (this.loginForm.valid) {
      this.loading = true;
      this._AuthService.login(this.loginForm.value, this.isAdmin).subscribe({
        next: (response: ILoginResponse) => {
          if (response.success === true && response.data.token !== '') {
            this.loading = false;
            {
              this._SessionService.setSession({
                access_token: response.data.token,
              });

              this._SessionService.setSession({
                user_role: this.isAdmin
                  ? ROLES.ROLE_SUPER_ADMIN
                  : ROLES.CORPORATOR,
              });
              this._SessionService.setSession({
                data: JSON.stringify(response.data),
              });
            }
            this._NotifierService.showSuccess(response.message);

            this.router.navigate([
              this.isAdmin ? '/admin/dashboard' : '/corporate/dashboard',
            ]);
            this._LoaderService.setState(false);
            this.loading = false;
          }
        },
        error: (error: IError) => {
          this.loading = false;
          console.log(
            'error inside login component=====>>',
            error.error?.message
          );
          this._NotifierService.showError(error.error?.message);
          this.activeRoute.snapshot.routeConfig?.path === 'admin-login' ? this.router.navigate(['/admin-login']) : this.router.navigate(['/'])
        },
      });
    }
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
